// Formatting helpers — INR & Indian locale.

export function formatINR(amount, opts = {}) {
  const n = Number(amount || 0);
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: opts.decimals ?? 0,
  }).format(n);
}

export function formatCompactINR(amount) {
  const n = Number(amount || 0);
  if (Math.abs(n) >= 10000000) return `₹${(n / 10000000).toFixed(2)} Cr`;
  if (Math.abs(n) >= 100000) return `₹${(n / 100000).toFixed(2)} L`;
  if (Math.abs(n) >= 1000) return `₹${(n / 1000).toFixed(1)}K`;
  return formatINR(n);
}

export function formatNumber(n) {
  return new Intl.NumberFormat("en-IN").format(Number(n || 0));
}

export function formatPercent(n) {
  return `${Number(n || 0).toFixed(1)}%`;
}

export function initials(name) {
  if (!name) return "?";
  return name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0].toUpperCase())
    .join("");
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return iso;
  }
}

export function formatDateTime(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

export const ROLE_LABEL = {
  admin: "Admin",
  manager: "Manager",
  team_leader: "Team Leader",
  sales_executive: "Sales Executive",
};
